import React from 'react'

const VehicleGps = () => {
  return (
    <div className='__vhlMain_fx ' style={{background: '#fafafa'}}>
        <div className='__gpsRedirect_px'>
            <p>Redirect to  GPS Tracker Page <br /> And Vehicle Number will be Preselected</p>
            </div>
    </div>
  )
}

export default VehicleGps